import React, { ReactNode } from 'react';
import {
  MenuItem,
  ListItemIcon,
  ListItemText,
  Popover,
} from '@material-ui/core';
import { ActionMenuItems } from './types';
import {
  AWSActionType,
  AWSResourceType,
  GCPActionType,
  GCPResourceType,
  KubernetesActionType,
  KubernetesResourceType,
  AzureActionType,
  AzureResourceType,
  ProjectCodeActionType,
  ProjectCodeResourceType,
} from '@internal/backstage-plugin-compute-resource-discovery-new-common';

type ActionServicePair =
  | { action: AWSActionType; service: AWSResourceType }
  | { action: GCPActionType; service: GCPResourceType }
  | { action: KubernetesActionType; service: KubernetesResourceType }
  | { action: AzureActionType; service: AzureResourceType }
  | { action: ProjectCodeActionType; service: ProjectCodeResourceType };

interface ActionMenuProps<T extends ActionServicePair = ActionServicePair> {
  handleActionClick: (action: T['action'], service: T['service']) => void;
  handleMenuClose: () => void;
  menuPosition: { mouseX: number | null; mouseY: number | null };
  menuItems: ActionMenuItems<T['action'], T['service']>[];
  additionalMenuItems?: ReactNode[];
}

export function ActionMenu<T extends ActionServicePair = ActionServicePair>({
  handleActionClick,
  handleMenuClose,
  menuPosition,
  additionalMenuItems,
  menuItems,
}: ActionMenuProps<T>) {
  return (
    <Popover
      open={menuPosition.mouseX !== null}
      onClose={handleMenuClose}
      anchorReference="anchorPosition"
      anchorPosition={
        menuPosition.mouseY !== null && menuPosition.mouseX !== null
          ? { top: menuPosition.mouseY, left: menuPosition.mouseX }
          : undefined
      }
    >
      {menuItems.map(item => (
        <MenuItem
          key={item.action}
          onClick={() => handleActionClick(item.action, item.service)}
          disabled={item.disabled}
        >
          <ListItemIcon>{item.icon}</ListItemIcon>
          <ListItemText>{item.text}</ListItemText>
        </MenuItem>
      ))}
      {additionalMenuItems?.map((additionalMenuItem, index) => (
        <React.Fragment key={`additional-menu-item-${index}`}>
          {additionalMenuItem}
        </React.Fragment>
      ))}
    </Popover>
  );
}
